<template lang="pug">
.cooperation-system-table-component
  //- テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    //- ヘッダー：アカウントの連携設定状態
    template(#head(use)="data")
      div アカウントの
      div 連携設定状態

    //- セル：システム名
    template(#cell(systemName)="row")
      .company-name {{ row.item.companyName }}
      a.system-name(:href="row.item.systemUrl" target="_blank") {{ row.item.systemName }}
    //- セル：部屋定員
    template(#cell(use)="row")
      span.use-system(v-if="row.item.use == true") 連携中
      span.unuse-system(v-else) 未連携
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### システム連携テーブルコンポーネント
 */
@Component({})
export default class CooperationSystemTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<CooperationSystemTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<CooperationSystemTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<CooperationSystemTableItem> {
    return this.value;
  }
}

/** テーブルの列名の情報 */
export interface CooperationSystemTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface CooperationSystemTableItem {
  companyName: string;
  systemName: string;
  systemUrl: string;
  systemType: string;
  functionName: string;
  use: boolean;
  cost: string;
}
</script>
